import React from 'react';
import Table from './table/Table';
import {observer, inject} from 'mobx-react'
import {cdn} from '../helpers/cdn';

const metadata = {
    icon: cdn('icons/!.png'),
    title: 'Top Commands',
    colorPrimary: '#f5a623',
    colorSecondary: '#fcf8cf',
};

@inject('store') @observer
class CommandTable extends React.Component {
    render() {
        const {store} = this.props;
        const {items, status} = store.commands;
        return (
            <Table tableMetadata={metadata} status={status} data={items} tableType="commands"/>
        )
    }
}

export default CommandTable;



// WEBPACK FOOTER //
// ./src/app/components/CommandTable.js